import { render } from "./CharacterInfo.vue?vue&type=template&id=554c4cca&scoped=true&ts=true"
import script from "./CharacterInfo.vue?vue&type=script&lang=ts"
export * from "./CharacterInfo.vue?vue&type=script&lang=ts"

import "./CharacterInfo.vue?vue&type=style&index=0&id=554c4cca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554c4cca"]])

export default __exports__